import { render, staticRenderFns } from "./WelcomeBanner.vue?vue&type=template&id=81e14554&"
import script from "./WelcomeBanner.vue?vue&type=script&lang=js&"
export * from "./WelcomeBanner.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeBanner.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "WelcomeBanner.vue"
export default component.exports